import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import CustomLinearProgress from '@src/new-components/LinearProgress';
import Typography from '@src/new-components/Typography';
import { StyledProcessingAudio, StyledRecordVerify } from './index.style';
import PreviewAudio from './PreviewAudio';

const ProcessingAudio = ({
  metadataAudio,
  title,
  progress,
  audioError,
  loadingVerifyVoice,
  verifyYourVoice,
  handleReset,
  voiceCheckStatus,
}) => {
  const { t } = useTranslation();

  return (
    <StyledRecordVerify>
      <Typography
        component="p"
        textTransform="uppercase"
        color={COLOR.descriptionUpload}
        variant="body-14-medium"
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '40px',
          justifyContent: 'center',
          margin: '0 auto',
        }}
      >
        {t('verifyYourVoice')}
      </Typography>

      {metadataAudio?.audioLink ? (
        <PreviewAudio
          metadataAudio={metadataAudio}
          audioError={audioError}
          handleReset={handleReset}
          loadingVerifyVoice={loadingVerifyVoice}
          verifyYourVoice={verifyYourVoice}
          voiceCheckStatus={voiceCheckStatus}
        />
      ) : (
        <StyledProcessingAudio>
          <div className="processing-audio-container">
            <Typography
              color={COLOR.descriptionUpload}
              variant="body-16-regular"
              sx={{
                marginBottom: '16px',
              }}
            >
              {t(title)}
            </Typography>
            <Typography color={COLOR.darkBlue} variant="body-16-bold">
              {progress}%
            </Typography>
          </div>
          <CustomLinearProgress
            variant="determinate"
            variantCustom="light-blue"
            value={progress}
          />
        </StyledProcessingAudio>
      )}
    </StyledRecordVerify>
  );
};

export default ProcessingAudio;
